import { render, staticRenderFns } from "./DisagreeExistingSpouseSupport.vue?vue&type=template&id=1838e1fd"
import script from "./DisagreeExistingSpouseSupport.vue?vue&type=script&lang=ts"
export * from "./DisagreeExistingSpouseSupport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports